import { Col, Row } from "antd";
import React from "react";
import Container from "../../Components/Container";
import Input from "../../Components/Form/Input";
import AkoModal from "../../Components/Modal";
import {
  Bill,
  ProfileIcon,
  ShieldTick,
  ProfileTick,
  ShieldSearch,
  PictureFrame,
  ProfileCircle,
  PersonalCard,
  Location,
  Profile2User,
  Mobile,
  Sms,
  PasswordCheck,
} from "../../Utils/icons";
import { useProfile } from "./Hooks";

const Profile = () => {
  const { user, isPerson, form, setForm, render } = useProfile();

  return (
    <Row gutter={20}>
      {isPerson() ? (
        <>
          <Col lg={16} className="mb-sm-25">
            <Container icon={() => <PersonalCard />} title="مشخصات شما">
              <Row gutter={15}>
                <Col lg={12} span={24}>
                  <Input
                    label="نام و نام خانوادگی"
                    props={{
                      value: user?.user?.accountable?.full_name,
                      disabled: true,
                    }}
                    leftIcon={() => <Bill />}
                  />
                </Col>
                <Col lg={12} span={24}>
                  <Input
                    label="کد ملی"
                    props={{
                      value: user?.user?.accountable?.national_code,
                      disabled: true,
                    }}
                    leftIcon={() => <ProfileIcon />}
                  />
                </Col>
                <Col lg={24} span={24}>
                  <Input
                    label="آدرس پستی"
                    props={{
                      value: user?.user?.address,
                      disabled: true,
                    }}
                    leftIcon={() => <ShieldTick />}
                  />
                </Col>
                {/* <Col lg={12} span={24}>
                  <Input
                    label="کد پستی"
                    props={{ value: "۱۲۳۴۵۶۷۸۹", disabled: true }}
                    leftIcon={() => <ShieldSearch />}
                  />
                </Col> */}
              </Row>
              <p className="help-form fw-600 lh-19 fs-11 text-footer text-center">
                مشخصات شما قابل تغییر نیست، در صورت لزوم با کارشناسان ما در
                ارتباط باشید.
              </p>
            </Container>
          </Col>
        </>
      ) : (
        <>
          <Col lg={16} className="mb-sm-25">
            <Container icon={() => <PersonalCard />} title="مشخصات شما">
              <Row gutter={15}>
                <Col lg={12} span={24}>
                  <Input
                    label="نام شرکت"
                    props={{
                      value: user?.user?.accountable?.company_name,
                      disabled: true,
                    }}
                    leftIcon={() => <Bill />}
                  />
                </Col>
                <Col lg={12} span={24}>
                  <Input
                    label="نام نماینده"
                    props={{
                      value:
                        user?.user?.accountable?.company_representative_name,
                      disabled: true,
                    }}
                    leftIcon={() => <ProfileIcon />}
                  />
                </Col>
                <Col lg={12} span={24}>
                  <Input
                    label="شناسه ملی"
                    props={{
                      value: user?.user?.accountable?.national_id,
                      disabled: true,
                    }}
                    leftIcon={() => <ShieldTick />}
                  />
                </Col>
                <Col lg={12} span={24}>
                  <Input
                    label="کد ملی نماینده"
                    props={{
                      value:
                        user?.user?.accountable
                          ?.company_representative_national_code,
                      disabled: true,
                    }}
                    leftIcon={() => <ProfileTick />}
                  />
                </Col>
                <Col lg={12} span={24}>
                  <Input
                    label="شماره ثبت"
                    props={{
                      value:
                        user?.user?.accountable?.company_registration_number,
                      disabled: true,
                    }}
                    leftIcon={() => <ShieldSearch />}
                  />
                </Col>
                <Col lg={12} span={24}>
                  <Input
                    label="کد پستی"
                    props={{
                      value: user?.user?.postal_code,
                      disabled: true,
                    }}
                    leftIcon={() => <PictureFrame />}
                  />
                </Col>
                <Col span={24}>
                  <Input
                    label="آدرس پستی"
                    props={{
                      value: user?.user?.address,
                      disabled: true,
                    }}
                    leftIcon={() => <Location />}
                  />
                </Col>
              </Row>
              <p className="help-form fw-600 lh-19 fs-11 text-footer text-center">
                مشخصات شما قابل تغییر نیست، در صورت لزوم با کارشناسان ما در
                ارتباط باشید.
              </p>
            </Container>
          </Col>
        </>
      )}

      <Col lg={8}>
        <Container icon={() => <ProfileCircle />} title="تنظیمات حساب کاربری">
          <Row>
            <Col span={24}>
              <Input
                leftIcon={() => <Profile2User />}
                label="نوع حساب کاربری:"
                props={{
                  value: isPerson() ? "حقیقی" : "حقوقی",
                  disabled: true,
                }}
              />
            </Col>{" "}
            <Col span={24}>
              <Input
                props={{
                  value: user?.user?.mobile,
                  disabled: true,
                }}
                label="موبایل"
                leftIcon={() => <Mobile />}
              />
            </Col>{" "}
            <Col span={24}>
              <Input
                leftIcon={() => <Sms />}
                props={{
                  value: user?.user?.email,
                }}
                forEdit={true}
                label="ایمیل"
                onClick={() => {
                  setForm({ show: "email" });
                }}
              />
            </Col>
            <Col span={24}>
              <Input
                props={{ value: "**************" }}
                leftIcon={() => <PasswordCheck />}
                label="گذرواژه"
                forEdit={true}
                onClick={() => {
                  setForm({ show: "password" });
                }}
              />
            </Col>
          </Row>
          <p className="help-form fw-600 lh-19 fs-11 text-footer text-center">
            نوع حساب کاربری و شماره موبایل قابل تغییر نیست، در صورت لزوم با
            <br />
            کارشناسان ما در تماس باشید.
          </p>
        </Container>
      </Col>
      <AkoModal
        onClose={() => {
          setForm({ show: false });
        }}
        open={form.show}
      >
        {render()}
      </AkoModal>
    </Row>
  );
};

export default Profile;
